import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import styled from 'styled-components';
import { Flex } from '@magnetic/flex';
import Footer from '../../../common/footer';
const FooterContainer = styled(Flex) `
  height: 100%;
  margin-top: 1vw;
`;
const NavigatorFooter = memo(() => {
    return (_jsx(FooterContainer, Object.assign({ direction: "vertical", justify: "flex-end" }, { children: _jsx(Footer, {}) })));
});
export default NavigatorFooter;
